<template>
  <b-row>
    <b-colxx class="disable-text-selection">
      <b-row>
        <b-colxx xxs="12">
          <h1>{{ $t('menu.shop-register-status') }}</h1>
          <piaf-breadcrumb/>
          <div class="separator mb-5"/>
        </b-colxx>
      </b-row>

      <b-card>
        <b-row class="mb-4">
          <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0">
            <div class="form-group has-float-label">
              <v-select :options="searchOption" v-model="searchValue" :reduce="item=>item.value" label="label" :searchable ="false"></v-select>
              <span>검색유형</span>
            </div>
          </b-colxx>

          <b-colxx xxs="12" md="6" lg="4" xl="4">
              <b-input-group class="mb-3">
                <b-input :placeholder="searchPlaceholder" v-model="search" @keyup.enter="searchData"/>

                <b-input-group-append>
                  <b-button v-show="!searchFlag" @click="searchData" variant="outline-primary default">
                    {{$t('button.search')}}
                  </b-button>
                </b-input-group-append>

<!--                <b-button v-show="!searchFlag" @click="searchData" variant="outline-primary default" size="sm">-->
<!--                  {{$t('button.search')}}-->
<!--                </b-button>-->
<!--                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary default" size="sm">-->
<!--                  {{$t('button.search-cancel')}}-->
<!--                </b-button>-->
              </b-input-group>
          </b-colxx>
          <div class="newWrap">
            <div class="top-right-button-container">
              <b-button :to="toSitePath('/shop/shop-register-request')" variant="primary" size="lg"
                        class="top-right-button">신규 매장 등록 신청
              </b-button>
<!--              <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-primary" class="d-inline-block"-->
<!--                          size="md">-->
<!--                <b-dropdown-item v-for="(size,index) in pageSizes" :key="index" @click="changePageSize(size)">{{size }}-->
<!--                </b-dropdown-item>-->
<!--              </b-dropdown>-->
            </div>
          </div>
        </b-row>

        <template v-if="isLoad">
          <b-row>
            <b-colxx xxs="12" class="mb-3" v-for="(item,index) in items" :key="index" :id="item.id">
              <b-card @click.prevent="clickItem($event,item.storeRegisterId)" style="cursor:pointer;" :class="{'d-flex flex-row':true }" no-body>
<!--                <img :src="item.img" class="list-thumbnail responsive border-0" style="margin:25px 10px; height:100px;"-->
<!--                     :alt="item.storeName"/>-->
                <div class="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div
                    class="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    <p class="list-item-heading mb-0 w-30 truncate">{{item.storeName}}</p>
                    <p class="mb-0 text w-20 ">{{ getStoreType(item.storeType) }}
                     </p>

                    <p class="mb-0 w-20">{{item.requestedDate.substr(0,10)}}</p>
                    <div class="mb-0 w-10">
                      <h3 class="mt-2">
                        <b-badge v-if="item.registerStatus == 'RegRequested'" variant="primary" size="lg">승인대기</b-badge>
                        <b-badge v-if="item.registerStatus != 'RegRequested'" variant="outline-primary" size="lg">임시저장</b-badge>
                      </h3>
                    </div>

                    <div class="w-10">
                      <b-button @click.stop @click="deleteReqStore(item.storeRegisterId)" variant="outline-black">
                        <b-icon icon="trash" scale="1"></b-icon>
                      </b-button>
                    </div>

                  </div>
                </div>
              </b-card>
            </b-colxx>
            <b-colxx xxx="12" class="mb-3" v-if="items.length === 0">
              <b-card :class="{'d-flex flex-row':true }" no-body>
                <div class="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div
                    class="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    <h4 style="text-align:center;width:100%">조회 내용이 없습니다.</h4>
                  </div>
                </div>
              </b-card>
            </b-colxx>
          </b-row>

          <b-row v-if="lastPage > 1">
            <b-colxx xxs="12">
              <b-pagination
                size="sm"
                align="center"
                :total-rows="total"
                :per-page="perPage"
                v-model="currentPage"
              >
                <template v-slot:next-text>
                  <i class="simple-icon-arrow-right"/>
                </template>
                <template v-slot:prev-text>
                  <i class="simple-icon-arrow-left"/>
                </template>
                <template v-slot:first-text>
                  <i class="simple-icon-control-start"/>
                </template>
                <template v-slot:last-text>
                  <i class="simple-icon-control-end"/>
                </template>
              </b-pagination>
            </b-colxx>
          </b-row>
        </template>

        <template v-else>
          <div class="loading"></div>
        </template>
      </b-card>
    </b-colxx>
  </b-row>
</template>

<script>
  import {
    DataListIcon
  } from '../../components/Svg'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import api from '../../constants/api'
  import {
    mapGetters,
    mapActions
  } from "vuex"
  import {getStoreType} from "@/utils";
  export default {
    components: {
      'data-list-icon': DataListIcon,
      'v-select': vSelect
    },
    data() {
      return {
        isLoad: false,
        searchFlag: false,
        keywordType: 'StoreNameContaining',
        displayMode: 'thumb',
        search: '',
        searchValue : 'StoreNameContaining',
        searchPlaceholder : '매장 이름을 입력해 주세요.',
        searchOption: this.setOption !== undefined ? this.setOption : [
          // {label: '브랜드코드', value: 'BrandCode'},
          // {label: '브랜드이름', value: 'BrandNameContaining'},
          {label: '매장코드', value: 'StoreCode'},
          {label: '매장이름', value: 'StoreNameContaining'},
          // {label: '관리자 ID', value: 'ManagerID'}
        ],
        currentPage: 1,
        perPage: 10,
        total: 0,
        pageSizes: [10, 20, 30],
        items: [],
        lastPage: 0
      }
    },
    methods: {
      getStoreType,

      searchCancel() {
        this.searchFlag = false;
        this.search = '';
        this.searchData();
      },

      deleteReqStore(itemId) {
        const params = {storeRegisterId: itemId}

        if(confirm('해당 매장을 삭제하시겠습니까? 삭제된 매장 정보는 복구 할수 없습니다.')) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.draftDelete)

          this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if(res.data.code === "OK") {
              
              alert("삭제되었습니다. ")
              this.$router.go(0)
            } else {
              throw 400
            }
          }).catch(err => {
            alert(err.response.data.message);
          })

        }
      },



      searchData() {


        let params =
          {
            keywordType : this.searchValue,
            keyword : this.search

        }
        this.isLoad = true;
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.requestList)
        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          
          const _data = res.data.data;
          this.items = _data;

          this.lastPage = _data.totalPages;
          this.total = _data.totalElements;
          this.perPage = _data.size;


          // this.items[0].img = '/assets/img/bebinca-thumb.jpg'

          this.isLoad = true;

        }).catch(err => {
          alert(err.response.data.message);
          if (err.response.data.message == "브랜드 관리자 권한이 없습니다.") {
            // this.$router.push(`/${this.siteName}/booking/booking-request`);
            console.log(JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')).userRole)
          }
          }
        );
        this.isLoad = false
      },

      changeStatus(itemId) {
        console.log(itemId)
      },

      changePageSize(perPage) {
        this.currentPage = 1
        this.perPage = perPage
      },

      clickItem(event, itemId) {
        this.$router.push(`/${this.siteName}/shop/shop-register-request/${itemId}`);
        // this.$router.push({name : 'shop-register', params : { storeCode : itemId}});
      },

      toSitePath(pathTo) {
        return "/" + this.siteName + pathTo;
      }
    },
    computed: {
      ...mapGetters(["currentUser", "siteName"]),
    },
    watch: {
      currentPage() {
        this.searchData()
      },

      searchValue(value){
        if(value == "StoreNameContaining") {
          this.searchPlaceholder = "매장 이름을 입력해 주세요."
        } else {
          this.searchPlaceholder = "매장 코드를 입력해 주세요."
        }
      },

    },
    mounted() {
      this.searchData()
    }
  }
</script>

